/**
 * Module-level fabric.Canvas holder.
 * Avoids putting non-serializable objects in Zustand.
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let _canvas: any = null

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function setCanvasInstance(canvas: any) {
    _canvas = canvas
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getCanvasInstance(): any {
    return _canvas
}
